export const defaultI18nConfig = {
	lng: 'en',
	fallbackLng: 'en',
	supportedLngs: ['en'],
	fallbackNS: ['common'],
	interpolation: {
		escapeValue: false,
	},
} as const;
